import React, { FunctionComponent, useEffect } from "react";
import styles from "./Spots.module.scss";
import SpotsProps from "./SpotsProps.interface";
import Spot from "./components/Spot/Spot";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import BubbleBackground from "components/BubbleBackground/BubbleBackground";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useAnchorIdentifier from "hooks/useAnchorIdentifier";
import isBrowserContext from "helpers/isBrowserContext";

const Spots: FunctionComponent<SpotsProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const identifier = useAnchorIdentifier(props.settings.anchorIdentifier);

    // ANIMATION
    const controls = useAnimation();
    const { ref, inView } = useInView({ threshold: 0.3 });

    const animateUp = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: 80, opacity: 0 }
    };
    const animateDown = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: -80, opacity: 0 }
    };

    const selectAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content._contentType : undefined;
    const selectVariants = selectAnimation === "animateUp" ? animateUp : selectAnimation === "animateDown" ? animateDown : undefined;
    const repeatAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content.repeatAnimation : false;

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
        if (!inView && repeatAnimation) {
            controls.start("hidden");
        }
    }, [controls, inView]);

    return (
        <motion.section className={combineClasses([styles.wrapper, ...wrapperClasses])} id={identifier} ref={ref} initial={isBrowserContext() ? "hidden" : "shown"} animate={controls} variants={selectVariants} transition={{ duration: 0.4 }}>
            <div className={styles.container}>
                {/* Spots */}
                {props.content.spots && props.content.spots.length > 0 ? (
                    <div className={styles.list}>
                        {props.content.spots.map((item, index) => {
                            return (
                                <Spot key={index} {...item} />
                            );
                        })}
                    </div>
                ) : null}
            </div>

            {props.settings.bubbleBackground && props.settings.bubbleBackground.length > 0 ? (
                <BubbleBackground {...props.settings.bubbleBackground[0]} />
            ) : null}
        </motion.section>
    );
};

export default Spots;